/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.includes.js";
import localCache from '@/utils/localCache';
import useProSumary from './hooks/useProSummary';
import { useEmptyStringFormat } from '@/hooks/fn';
import useLineStatus from './hooks/useLineStatus';
import useAttendance from './hooks/useAttendance';
import useSaleSummary from './hooks/useSaleSummary';
import { PieEchart } from '@/components/page-echarts';
import useReceiveSummary from './hooks/useReceiveSummary';
import useMoneyPermission from './hooks/useMoneyEditPermission';
import useCollectionCorrection from './hooks/useCollectionCorrection';
import useCanShowBlueSkyBudget from './hooks/useCanShowBlueSkyBudget';
import useBudgetSurvey from '@/views/Operate/BudgetReport/hooks/useBudgetSurvey';
import useSjProData from '@/views/Production/ProReportMortar/hooks/useStatisticsData';
import useStProData from '@/views/Production/ProReportShangTong/hooks/useStatisticsData';
export default defineComponent({
  name: 'ProdComprehensiveDaily',
  components: {
    PieEchart: PieEchart
  },
  setup: function setup() {
    var emptyStringFormat = useEmptyStringFormat();
    var _useCanShowBlueSkyBud = useCanShowBlueSkyBudget(),
      _useCanShowBlueSkyBud2 = _slicedToArray(_useCanShowBlueSkyBud, 2),
      showBlueSkyBudget = _useCanShowBlueSkyBud2[0],
      canShowBlueSkyBudgetAsync = _useCanShowBlueSkyBud2[1];
    var params = ref({
      date: dayjs().format('YYYY-MM-DD'),
      type: 0
    });
    var curDate = ref(dayjs().format('YYYY/MM/DD'));
    var curDate1 = ref(dayjs().format('MM/DD'));
    //当前日期区间
    var date = ref({
      startTime: dayjs().format('YYYY/MM/DD') + ' 00:00:00',
      endTime: dayjs().format('YYYY/MM/DD') + ' 23:59:59'
    });
    //收款参数
    var accountParams = ref({
      search_day: dayjs().format('YYYY-MM-DD'),
      search_month: dayjs().format('YYYY-MM')
    });
    var isNotInFacIds = computed(function () {
      var facIds = ['187', '165'];
      var factoryId = localCache.getItem('factoryId');
      return !_.includes(facIds, factoryId);
    });
    //获取产线数据
    var _useLineStatus = useLineStatus(),
      _useLineStatus2 = _slicedToArray(_useLineStatus, 2),
      lineStatusList = _useLineStatus2[0],
      getLineStatusAsync = _useLineStatus2[1];
    //获取考勤数据
    var _useAttendance = useAttendance(params),
      _useAttendance2 = _slicedToArray(_useAttendance, 4),
      require_count = _useAttendance2[0],
      attendanceData = _useAttendance2[1],
      getAttendanceAsync = _useAttendance2[2],
      attendaceEchartData = _useAttendance2[3];
    // 获取产量数据
    var _useProSumary = useProSumary(params),
      _useProSumary2 = _slicedToArray(_useProSumary, 2),
      proSumary = _useProSumary2[0],
      getProSumary = _useProSumary2[1];
    // 获取商砼自采耗用数据
    var _useStProData = useStProData(params),
      _useStProData2 = _slicedToArray(_useStProData, 3),
      stReceivingData = _useStProData2[0],
      getCommercialReceiveStatisticsAsyc = _useStProData2[2];
    // 获取砂浆自采耗用数据
    var _useSjProData = useSjProData(params),
      _useSjProData2 = _slicedToArray(_useSjProData, 3),
      sjReceivingData = _useSjProData2[0],
      getMortarReceiveStatisticsAsyc = _useSjProData2[2];
    //获取销量数据和产量的商砼砂浆产量数据
    var _useSaleSummary = useSaleSummary(params),
      _useSaleSummary2 = _slicedToArray(_useSaleSummary, 6),
      saleSummary = _useSaleSummary2[0],
      saleData = _useSaleSummary2[1],
      purchaseData = _useSaleSummary2[2],
      getSaleSummaryAsync = _useSaleSummary2[3],
      getSaleSummaryAsync1 = _useSaleSummary2[4],
      getPurchaseSummaryAsync = _useSaleSummary2[5];
    console.log(saleSummary);
    //获取领用数据
    var _useReceiveSummary = useReceiveSummary(params),
      _useReceiveSummary2 = _slicedToArray(_useReceiveSummary, 2),
      receiveData = _useReceiveSummary2[0],
      getReceiveSummaryAsync = _useReceiveSummary2[1];
    //获取收款数据
    var _useCollectionCorrect = useCollectionCorrection(params),
      _useCollectionCorrect2 = _slicedToArray(_useCollectionCorrect, 3),
      getCollectionInfoAsync = _useCollectionCorrect2[1],
      collectionList = _useCollectionCorrect2[2];
    //预算概况参数
    var budgetParams = ref({
      month: dayjs().format('YYYY-MM')
    });
    //获取预算概况数据
    var _useBudgetSurvey = useBudgetSurvey(budgetParams),
      _useBudgetSurvey2 = _slicedToArray(_useBudgetSurvey, 2),
      budgetSurvey = _useBudgetSurvey2[0],
      getBudgetSurveyAsync = _useBudgetSurvey2[1];
    // 获取是否有修改收款权限
    var _useMoneyPermission = useMoneyPermission(),
      _useMoneyPermission2 = _slicedToArray(_useMoneyPermission, 2),
      moneyEditPermission = _useMoneyPermission2[0],
      getMoneyPermissionAsync = _useMoneyPermission2[1];
    var confrimDate = function confrimDate(val) {
      accountParams.value.search_day = dayjs(val).format('YYYY-MM-DD');
      accountParams.value.search_month = dayjs(val).format('YYYY-MM');
      params.value.date = dayjs(val).format('YYYY-MM-DD');
      curDate.value = dayjs(val).format('YYYY/MM/DD');
      date.value.startTime = dayjs(val).format('YYYY/MM/DD') + ' 00:00:00';
      date.value.endTime = dayjs(val).format('YYYY/MM/DD') + ' 23:59:59';
      budgetParams.value.month = dayjs(val).format('YYYY-MM');
      //获取产线数据
      getLineStatusAsync();
      //获取考勤数据
      getAttendanceAsync();
      // 获取产量汇总
      getProSumary();
      //获取销量和产量的商砼砂浆产量数据
      getSaleSummaryAsync();
      getSaleSummaryAsync1();
      //获取采购数据
      getPurchaseSummaryAsync();
      //获取领用数据
      getReceiveSummaryAsync();
      //获取收款数据
      getCollectionInfoAsync();
      if (showBlueSkyBudget.value === '1') {
        //获取预算数据
        getBudgetSurveyAsync();
      }
      // 获取商砼自采耗用
      getCommercialReceiveStatisticsAsyc();
      // 获取砂浆自采耗用
      getMortarReceiveStatisticsAsyc();
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            //获取产线数据
            getLineStatusAsync();
            //获取考勤数据
            getAttendanceAsync();
            // 获取产量汇总
            getProSumary();
            //获取销量和产量的商砼砂浆产量数据
            getSaleSummaryAsync();
            getSaleSummaryAsync1();
            //获取采购数据
            getPurchaseSummaryAsync();
            //获取领用数据
            getReceiveSummaryAsync();
            //获取收款数据
            getCollectionInfoAsync();
            // 获取商砼自采耗用
            getCommercialReceiveStatisticsAsyc();
            // 获取砂浆自采耗用
            getMortarReceiveStatisticsAsyc();
            // 获取是否有修改收款的权限
            getMoneyPermissionAsync();
            _context.next = 13;
            return canShowBlueSkyBudgetAsync();
          case 13:
            if (showBlueSkyBudget.value === '1') {
              //获取预算数据
              getBudgetSurveyAsync();
            }
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var router = useRouter();
    var jumpPage = function jumpPage(routeName) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      router.push({
        name: routeName,
        params: params
      });
    };
    onBeforeUnmount(function () {
      localCache.deleteItem('defaultDate');
    });
    return {
      confrimDate: confrimDate,
      emptyStringFormat: emptyStringFormat,
      lineStatusList: lineStatusList,
      saleData: saleData,
      proSumary: proSumary,
      purchaseData: purchaseData,
      receiveData: receiveData,
      collectionList: collectionList,
      require_count: require_count,
      attendanceData: attendanceData,
      attendaceEchartData: attendaceEchartData,
      jumpPage: jumpPage,
      params: params,
      curDate: curDate,
      curDate1: curDate1,
      budgetSurvey: budgetSurvey,
      // 商砼自采耗用数据
      stReceivingData: stReceivingData,
      // 砂浆自采耗用数据
      sjReceivingData: sjReceivingData,
      // 收款是否有权限
      moneyEditPermission: moneyEditPermission,
      showBlueSkyBudget: showBlueSkyBudget,
      isNotInFacIds: isNotInFacIds
    };
  }
});